var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    borders = _ref.borders;
  return {
    userResponseShadowColor: colors.contrasts.white1010,
    correctColor: colors.contrasts.blue4570,
    incorrectColor: colors.contrasts.red4570,
    unknownColor: colors.contrasts.grey4570,
    wrapperBorderWidth: borders.widthLarge
  };
};
export default generateComponentTheme;